import { ICON_CLASSES } from '../constants/icon.constants'

export const MERCHANDISE_CONFIG = {
  sectionId: 'merchandise',
  heading: 'Merchandise',
  fullHeightImages: true,
  copy: [
    'Show your club colours with official Regis Road Runners merchandise. Our clothing line and bib clips are available from the shops below.',
  ],
  cards: [
    {
      imgSrc: '/rrr_merchandise.jpg',
      imgYBackgroundPosition: '50%',
      imgXBackgroundPosition: '50%',
      heading: 'Clothing line',
      copy: [
        'Official Regis Road Runners kit including club tops and more, available through our partner JW Sports.',
      ],
      links: [
        {
          buttonText: 'Shop club clothing',
          url: 'https://www.jwsports.co.uk/shop/category/club-shops-running-clubs-regis-road-runners-607',
          isButtonLink: true,
          icon: ICON_CLASSES.CART,
        },
      ],
    },
    {
      imgSrc: '/rrr_bib_clips.png',
      imageFit: 'cover',
      imageObjectPosition: 'center 85%',
      heading: 'Bib clips',
      copy: [
        'Regis Road Runners branded bib clips to keep your race number secure — available from Event Clip.',
      ],
      links: [
        {
          buttonText: 'Shop bib clips',
          url: 'https://eventclip.net/product/regis-road-runners/',
          isButtonLink: true,
          icon: ICON_CLASSES.CART,
        },
      ],
    },
  ],
}
